import React, { useCallback } from 'react';
import styled from 'styled-components';
import Typo from '../../../../components/atom/Typo';
import colors from '../../../../constants/colors.constants';
import { Reservation } from '../../../../apis/models/reservations/res/Reservation';
import strings from '../../../../constants/strings.constants';
import moment from 'moment-timezone';
import { renderReservationTag } from '../../../../utils/render-utils';
import useLanguageCodeStore from '../../../../store/useLanguageCodeStore';

export interface ReservationItemProps {
  reservation: Reservation;
  onClick?: (reservation: Reservation) => void;
}
function ReservationItem(props: ReservationItemProps) {
  const { reservation, onClick } = props;
  const { languageCode } = useLanguageCodeStore();

  const renderTag = useCallback(() => {
    const { reservationStatus, reservedAt } = reservation;
    return renderReservationTag(reservedAt, reservationStatus);
  }, [reservation]);

  const getReservationDateText = useCallback(() => {
    const { reservedAt } = reservation;

    if (languageCode !== 'ko') {
      return moment(reservedAt)
        .tz('Asia/Seoul')
        .format('YYYY.MM.DD. (dd) a hh:mm [(KST)]');
    } else {
      return moment(reservedAt)
        .tz('Asia/Seoul')
        .format('YYYY.MM.DD. (dd) a hh:mm');
    }
  }, [reservation, languageCode]);

  const getReservationName = useCallback(() => {
    const {
      productOptions = [],
      treatmentCategoryName,
      treatmentSubCategoryName,
      needConsultation,
    } = reservation;
    let reservationName = strings.consultingReservation;
    if (productOptions.length > 0) {
      const [option] = productOptions;
      let suffix = '';
      if (productOptions.length > 1) {
        suffix = `${productOptions.length - 1}${strings.unitReservationProductEA}`;
      }
      reservationName = `${option.productOptionName} ${suffix}`;
    } else {
      let categoryText = '';
      if (needConsultation) {
        categoryText += `[${strings.consultingReservationTag}] `;
      } else {
        categoryText += `[${strings.treatmentReservationTag}] `;
      }

      if (treatmentCategoryName) {
        categoryText += treatmentCategoryName;
      }
      if (treatmentSubCategoryName) {
        categoryText += ` / ${treatmentSubCategoryName}`;
      }
      if (categoryText) {
        reservationName = categoryText;
      }
    }
    return reservationName;
  }, [reservation]);

  return (
    <ReservationItemWrapper
      onClick={() => {
        if (onClick) {
          onClick(reservation);
        }
      }}
    >
      <div className="flex flex-col">
        <div className="mb-2">{renderTag()}</div>
        <div className="mb-1 flex gap-2">
          <Typo type="r-16" color={colors.slate500}>
            {getReservationDateText()}
          </Typo>
        </div>
        <Typo type="m-16">{getReservationName()}</Typo>
      </div>
    </ReservationItemWrapper>
  );
}

export default ReservationItem;

const ReservationItemWrapper = styled.div`
  background: white;
  padding: 16px;
  border-radius: 20px;
  cursor: pointer;
`;
